// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3GKmS","choiceBoxes":"toolbarselects_choiceBoxes__3pGxg","simpleField":"toolbarselects_simpleField__20cNb"};